export class NavBarItems {
    items = [{
      ativo: false,
      nome: 'Página Inicial',
      url: '/'
    },
    {
      ativo: false,
      nome: 'Quem Somos',
      url: '/sobreNos'
    }, {
      ativo: false,
      nome: 'Serviços',
      url: '/servicos'
    },
    {ativo: false,
      nome: 'Treinamentos',
      url: '/treinamento' },
    {ativo: false,
      nome: 'Esocial',
      url: '/esocial'
    },
    {ativo: false,
      nome: 'Contato',
      url: '/contato'
    } ]
}



// WEBPACK FOOTER //
// ./src/model/navBar.js